import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Booking} from '../../core/Booking';
import { DataService } from 'src/app/core/data.service';
import {Router} from '@angular/router';
import {RestStateInterface} from '../../core/RestStateInterface';

@Component({
  selector: 'booking-list',
  templateUrl: './booking-list.component.html',
  styleUrls: ['./booking-list.component.css']
})
export class BookingListComponent implements OnInit, OnChanges  {
  // For the Booking Grid
  loading = true;
  selectedBooking: Booking = null;
  requestedPage = 0;
  maxPage: number;
  requestPageSize = 10;
  totalResults: number;
  @Output() refreshState: EventEmitter<RestStateInterface> = new EventEmitter();
  @Input()  bookingList: Booking[];
  @Input()  set total(total: number) {
    this.totalResults = total;
    this.maxPage = Math.ceil(total / this.requestPageSize) - 1;
  }
  constructor(private dataService: DataService, private router: Router) {}
    ngOnInit() {
      this.refresh();
    }

    refresh() {
      const pageFrom = this.requestedPage * this.requestPageSize;
      let pageTo = pageFrom + this.requestPageSize - 1;
      if (pageTo > this.totalResults) {
        pageTo = this.totalResults - 1;
      }
      const newState: RestStateInterface = {
        page: {
          from: pageFrom,
          to: pageTo,
          size: this.requestPageSize,
          current: this.requestedPage + 1
        }
      };
      // if (state.sort && state.sort.by == 'customerName') {
      //     state.sort.by = 'user.surname';
      // }
        this.refreshState.next(newState);
    }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['bookingList']) {
          this.loading = false;
      }
    }
    navToEdit($event: Booking) {
      this.router.navigate(['admin/bookStep', {bookingSid: $event.sid}]);
    }
    viewSummary($event: Booking) {
      this.dataService.callGet('bookings/' + $event.sid)
          .subscribe(
              (booking) => this.selectedBooking = booking,
              (error) => console.log(error));
    }
    actionDeleteBooking() {
      this.dataService.callDelete('bookings/' + this.selectedBooking.sid).subscribe(
          () => {
            this.selectedBooking = null;
            console.log('done');
          },
          error => {
            console.log(error);
          }
      );
    }

  orderBy(surname: string) {
    
  }
}
